<template>
  <div>
    <el-table
      :data="auditList"
    >
      <el-table-column
        label="时间">
        <template slot-scope="scope">
          {{scope.row.createTime | moment}}
        </template>
      </el-table-column>
      <el-table-column
        prop="userId"
        label="账号ID">
      </el-table-column>
      <el-table-column
        prop="name"
        label="部落名称">
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 0"
            type="primary"
            size="small"
            @click="approveAudit(scope.row)"
          >
            审核
          </el-button>
          <el-tag v-else type="success">使用中</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <pagination 
      :size="pagination.size" 
      :total="totalCount" 
      :page="pagination.page" 
      @pageChanged="pageChanged"
    ></pagination>
    <audit-detail :value="auditValue" @onUpdate="onUpdate"></audit-detail>
  </div>
</template>

<script>
import Pagination from 'components/pagination';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import AuditDetail from '../detail';

export default {
  name: 'tribeAudit',
  data() {
    return {
      auditValue: null,
      auditId: null
    };
  },
  components: {
    Pagination,
    AuditDetail
  },
  methods: {
    ...mapMutations('tribeAudit', ['toggleDetailDialogVisible', 'setPagination']),
    ...mapActions('tribeAudit', ['list', 'approve']),
    approveAudit(v) {
      this.auditId = v.id;
      this.auditValue = v;
      this.toggleDetailDialogVisible(true);
    },
    pageChanged(pagination) {
      this.$emit('refresh', pagination);
    },
    onUpdate() {
      this.$emit('refresh');
    }
  },
  computed: {
    ...mapState('tribeAudit', ['auditList', 'pagination', 'totalCount', 'activeTab'])
  }
};
</script>

<style lang="less" scoped>
</style>
